/**
 * Government ID number formats (ACCT-14) — the API's rules (api/app/core/govt_ids.py) and the
 * patient app's. Spaces, hyphens and case are ignored; `npm run check:govt-ids` compares these
 * with the API's verdicts.
 */

export interface GovtIdFormat {
  type: string;
  label: string;
  pattern: RegExp;
  /** What the number must be, for the hint and the error. */
  rule: string;
  example: string;
}

export const GOVT_ID_FORMATS: GovtIdFormat[] = [
  { type: "aadhaar", label: "Aadhaar", pattern: /^[2-9]\d{11}$/, rule: "12 digits, not starting with 0 or 1", example: "2345 6789 0123" },
  { type: "pan", label: "PAN", pattern: /^[A-Z]{5}\d{4}[A-Z]$/, rule: "5 letters, 4 digits and a letter", example: "ABCDE1234F" },
  { type: "dl", label: "Driving licence", pattern: /^[A-Z]{2}\d{13}$/, rule: "the state code and 13 digits", example: "TN01 20200012345" },
  { type: "passport", label: "Passport", pattern: /^[A-Z]\d{7}$/, rule: "a letter and 7 digits", example: "A1234567" },
  { type: "voter_id", label: "Voter ID", pattern: /^[A-Z]{3}\d{7}$/, rule: "3 letters and 7 digits", example: "ABC1234567" },
];

export const normaliseGovtId = (value: string): string => value.replace(/[\s-]/g, "").toUpperCase();

/** Why `number` isn't a valid ID of `type` (null when it is). */
export function govtIdProblem(type: string, number: string): string | null {
  const fmt = GOVT_ID_FORMATS.find((f) => f.type === type);
  if (!fmt) return "Choose the ID type.";
  return fmt.pattern.test(normaliseGovtId(number)) ? null : `${fmt.label} must be ${fmt.rule}.`;
}
